module.exports = __webpack_public_path__ + "img/second_poster.df1a477e.png";